import React from "react";
import { IoClose } from "react-icons/io5";
import { IoDocumentOutline } from "react-icons/io5";
import { FaSave } from "react-icons/fa";
import { GiCrossMark } from "react-icons/gi";
import { IoPrintSharp } from "react-icons/io5";
import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import vehicleMasterData from "../../../store/VehicleMasterERP";

const TankerCompartments = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const state = useSelector((state) => state.changeTheState);
  const user = state?.user?.emailId?.split("@")[0];
  const location = useLocation();
  const menu = location.state ? location.state.menu : null;
  const authToken = window.sessionStorage.getItem("auth-token");
 const BASEURL_GLOBAL =  process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const [isLoading, setIsLoading] = useState(true);
  const data = vehicleMasterData((state) => state.data);

  const [formData, setFormData] = useState({
    noOfCompartments: "",
    compartmentNo: "",
    capacity: "",
    data: [],
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  useEffect(() => {
    if (data?.OM_VEHICLE_REG_NO) {
      getData(data?.OM_VEHICLE_REG_NO);
    }
  }, [data]);

  const getData = (vehicle) => {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1362&OM_VEHICLE_REG_NO=${encodeURIComponent(vehicle)}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((res) => {
        handleChange(
          "noOfCompartments",
          res?.data[0]?.OM_VEHICLE_FUEL_COMPARTMENTS || 0,
        );
      })
      .catch((err) => {
        console.log("Error While fetching 1362", err);
      });

    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1135&VEHICLE=${encodeURIComponent(vehicle)}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((res) => {
        handleChange("data", res?.data);
      })
      .catch((err) => {
        console.log("Error While fetching 1135", err);
      });
  };

  return (
    <div className="text-xs">
      <div className="lg:flex lg:flex-col mt-3 justify-between bg-gray-100 p-2 m-2 rounded-md">
        {/* 1st Row  */}
        <div className="flex gap-5">
          <span className="lg:ml-2 w-[170px]">Number of Compartments:</span>
          <input
            className="w-40 h-6  border border-black p-2 focus:outline-none focus:border-blue-500"
            type="text"
            value={formData?.noOfCompartments}
            onChange={(e) => handleChange("noOfCompartments", e.target.value)}
          ></input>
          <button className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
            Save Number Of Compartments
          </button>
        </div>
        {/* 2nd Row  */}
        <div className="flex gap-5">
          <span className="lg:ml-2 w-[170px]">Compartment No:</span>
          <input
            className="w-40 h-6 text-right border border-black p-2 focus:outline-none focus:border-blue-500"
            type="number"
            value={formData?.compartmentNo}
            onChange={(e) => handleChange("compartmentNo", e.target.value)}
          ></input>
          <span className="lg:ml-2">Capacity of Compartment:</span>
          <input
            className="w-40 h-6 text-right  border border-black p-2 focus:outline-none focus:border-blue-500"
            type="number"
            value={formData?.capacity}
            onChange={(e) => handleChange("capacity", e.target.value)}
          ></input>
          <button className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
            Save Compartment Max Capacity
          </button>
        </div>
      </div>
        <aside className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
            <table className="w-auto border border-gray-300 text-sm">
              <thead class="sticky top-0 w-44">
                <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4  border border-gray-300 text-left">S NO</td>
              <td className="py-2 px-4  border border-gray-300 text-left">Compartment No</td>
              <td className="py-2 px-4  border border-gray-300 text-left">Capacity</td>
            </tr>
          </thead>
          <tbody>
            {formData?.data?.map((row, index) => (
              <tr
                                className="hover:bg-gray-100 cursor-pointer text-[12px]"
                key={index}
                onClick={() => {
                  handleChange("noOfCompartments", row?.COMPARTMENT);
                  handleChange("capacity", row?.CAPACITY);
                }}
              >
                <td className="py-2 px-4  border border-gray-300 text-right">{index + 1}</td>
                <td className="py-2 px-4  border border-gray-300 text-left">
                  {row?.COMPARTMENT ? row?.COMPARTMENT : ""}
                </td>
                <td className="py-2 px-4  border border-gray-300 text-left">
                  {row?.CAPACITY ? row?.CAPACITY : ""}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </aside>
    </div>
  );
};

export default TankerCompartments;
